import { getAcceptLanguageHeader } from './constants';

let currentLocale = 'en';

export function setApiLanguage(locale) {
  currentLocale = locale || 'en';
}

export function getApiLanguage() {
  return currentLocale;
}

export function getAcceptLanguage() {
  return getAcceptLanguageHeader(currentLocale);
}

/** Attach Accept-Language to an axios instance (call once per client). */
export function attachLanguageInterceptor(axiosInstance) {
  if (!axiosInstance?.interceptors?.request) return;
  axiosInstance.interceptors.request.use((config) => {
    config.headers = config.headers || {};
    if (!config.headers['Accept-Language']) {
      config.headers['Accept-Language'] = getAcceptLanguage();
    }
    return config;
  });
}
